import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { BllOrtak } from '../../../providers/bll/bll-ortak';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the IsdurumkayitPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-isdurumkayit',
  templateUrl: 'isdurumkayit.html',
})
export class IsdurumkayitPage {
  durum:any={ID:-1,IsDurum:""};
isdurum:any={};
  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public viewCtrl:ViewController,
     public navParams: NavParams) {
      if (navParams.get("isVw") != null) {
        this.isdurum = navParams.get("isVw");
        var data = new FormData();
        data.append("Durum_id", this.isdurum.ID);
        this.bllOrtak.islem(data, "DurumGetirByID", "", false).then(a => {
          var Sonuc = <any>a;
          this.durum = Sonuc.SonucObject;
          
        }
        )
      }
  }

  ionViewDidLoad() {

  }
  boslukKontrol() {
    var mesaj = "";
    
    if (this.durum.IsDurum == null || this.durum.IsDurum == "") {
      mesaj = mesaj + "Lütfen Durum adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();
   
    if (this.boslukKontrol()) {
      formData.append("Durum_json", JSON.stringify(this.durum));
     
      this.bllOrtak.islem(formData, "DurumEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
       

      })
    }
    this.cikis();
    }
    cikis()
    {
      this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/isdurumkayit/isdurumkayit.ts